import { forwardRef, InputHTMLAttributes } from "react";
import styles from "./Form.module.css";
import { cx } from "../utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
    <input ref={ref} className={cx(styles.input, className)} {...props} />
));

Input.displayName = "Input";
